<!--

  Note: this component will fire an event 'pathology-selected'  that must be handled by the parent component

-->
<template>
  <div id="dropdown" class="filter-pathologies" @click="setDropdownActive()" :class="{open: dropdownActive, active: selectedPathology}">
    <span v-if="!selectedPathology & !dropdownActive">{{defaultValue}}<img :src="srcSelect + '#icon-select-' + this.theme" width="9" height="6"></span>
    <span v-else-if="!selectedPathology & dropdownActive">{{defaultValue}}<img :src="srcSelect + '#icon-select-white'" width="9" height="6"></span>
    <span v-else>{{selectedValue}}<img :src="srcSelect + '#icon-select-white'" width="9" height="6"></span>
    <div class='dropdown'>
      <ApolloQuery :query="require('@/graphql/Pathologies.gql')">
        <template slot-scope="{ result: { error, data, loading }, isLoading }">
          <span v-if="data" :data="data">

            <!-- trigger an event 'pathology-selected' that must be handled by the parent component -->
            <a v-for="(pathology, index) in data.pathologies.edges" :key="index" class='drop-link' @click="changeValue(pathology)">{{pathology.node.name}}</a>

          </span>
          <div class="u-color--blue" v-if="isLoading">Loading&hellip;</div>
          <div v-if="error"><error/></div>
        </template>
      </ApolloQuery>
    </div>
  </div>
</template>

<script>
  import Error from "./Error";

  export default {
    name: "Dropdown",
    props: ['pathologies', 'selectedPathology', 'theme'],
    components: {Error},
    data: () => {
      return {
        dropdownActive: false,
        defaultValue: 'Choisir une pathologie',
        srcSelect: '',
        selectedValue: ''
      }
    },
    methods: {
      setDropdownActive() {
        this.dropdownActive = !this.dropdownActive
      },
      changeValue(pathology){
        this.$emit('pathology-selected', pathology.node.slug);
        this.selectedValue = pathology.node.name;
      }
    },
    mounted() {
      this.srcSelect = require(`@/assets/img/icons.svg`);
    }
  }
</script>

<style lang="scss">

  .filter-pathologies {
    padding: rem(12px) rem(20px) rem(10px) rem(30px);
    border: 1px solid #ddd!important;
    background: white;
    background:rgba(255,255,255,.5)!important;
    border-radius: rem(24px);
    font-size: rem(14px);
    transition: all 0.3s ease;
    text-align: left;
    list-style-type: none;
    font-weight: 600;
    cursor: pointer;
    display: inline-block;
    box-shadow:0 0 2em rgba(0,0,0,.1);

    &.open .dropdown {
      z-index:1;
      opacity:1;
      visibility: visible;
      transform:translateY(0px);
    }

    span {
      display: flex;
      align-items: center;
		white-space:nowrap;
      color:color(dark);

      img {
        margin-left: rem(50px);
        filter:brightness(.3);

        @include mq($until: MD) {
          margin-left: rem(10px);
          width: rem(5px);
          height: rem(8px);
        }
      }
    }

    .dropdown {
      z-index:-1;
      position: absolute;
      visibility: hidden;
      opacity: 0;
      background: white;
      border: 1px solid color(border);
      box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
      width: auto;
      margin-top: rem(25px);
      margin-left: rem(-30px);
      transition: all 0.3s ease;
      border-radius: 7px;
      transform: translateY(15px);
      cursor: default;

      span {
        display: flex;
        flex-direction: column;
        padding: 0 rem(15px);

        .drop-link {
          display: block;
          text-align: left;
          text-decoration: none;
          font-size: rem(15px);
          padding: rem(10px) rem(14px);
          transition: all 0.3s ease;
          width: 100%;
          position: relative;
          cursor: pointer;

          @include mq($until: MD) {
            padding: rem(8px) rem(14px);
          }

          &:first-child::before {
            content: "";
            top: rem(-8px);
            left: 45%;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 8px 8px 8px;
            border-color: transparent transparent #fff transparent;
            position: absolute;
          }

          &:hover{
            text-decoration: underline;
          }

          &:not(:first-child){
            border-top: 1px solid #d4dade;
          }
        }
      }

      @include mq($until: MD) {
        margin-left: rem(-10px);
        margin-top: rem(17px);
      }
    }

    @include mq($until: MD) {
      padding: rem(9px) rem(10px) rem(7px);
    }

    &.orange {
      color: color(orange);

      &.open, &.selected {
        background: color(orange);
        color: white;
        cursor:pointer;
      }

      .drop-link {
        color: color(orange);
      }
    }

    &.blue {
      color: color(blue);

      &.open, &.selected {
        background: color(blue);
        color: white;
        cursor:pointer;
      }

      .drop-link {
        color: color(blue);
      }
    }
  }

</style>
